import WorkstreamsContainer from "~/Workstreams/WorkstreamsContainer"

export default WorkstreamsContainer
